import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (param): boolean => Number(param) > 0;
